import React from 'react'

import {HeaderBar, HeaderContentBlock} from './Header.styles'
import HeaderActionsContainer from './headeractions/HeaderActions.container'
import HeaderSearchContainer from './headersearch/HeaderSearch.container'

import Typestack from '../../typestack'

const HeaderComponent = ({analytics, subStyling, multiselect, title, summary, events, filterDrawerOpen, setSearch, unsetSearch, search, i18n, api, download, headerButtons, env, selectedRows}) => {
  return (
    <HeaderBar data-testid='header-bar'>
      <div>
        <HeaderContentBlock>
          <Typestack style={{color: 'rgba(0, 0, 0, .65)'}} type='eyebrow' data-testid='sub-header'>{summary}</Typestack>
          <Typestack type='heading' size='xs' weight='black' data-testid='main-header' style={subStyling.styling}>
            {title}
            {subStyling && subStyling.label && subStyling.label.content &&
              <span style={subStyling.label.styling}>{subStyling.label.content}</span>
            }
          </Typestack>
        </HeaderContentBlock>

        <HeaderActionsContainer analytics={analytics} multiselect={multiselect} selectedRows={selectedRows} filterDrawerOpen={filterDrawerOpen} api={api} {...events} i18n={i18n} download={download} headerButtons={headerButtons} env={env} >
          <HeaderSearchContainer setSearch={setSearch} unsetSearch={unsetSearch} value={search} i18n={i18n} analytics={analytics} />
        </HeaderActionsContainer>

      </div>
    </HeaderBar>
  )
}

export {
  HeaderComponent
}
